import { Enumify } from 'enumify-ts';
class CommunicationCategoryType extends Enumify() {
    description;
    static DEFAULT = new CommunicationCategoryType("Default");
    static POD = new CommunicationCategoryType("Proof of Delivery");
    static DELIVERY_UPDATE = new CommunicationCategoryType("Delivery Update");
    static SALES = new CommunicationCategoryType("Sales");
    static SUPPLIER = new CommunicationCategoryType("Supplier");
    static _ = CommunicationCategoryType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
}
export default CommunicationCategoryType;
